(function () {
  var STORAGE_KEY = 'franquia_data';
  var MATCH_FIELD = 'identificador';
  var ATTR_PREFIX = 'franquia_';
  var dataList = window.FRANQUIAS_DATA || [];

  var params = new URLSearchParams(window.location.search);
  var paramValue = params.get('franquia');
  var matchedItem = null;

  if (paramValue) {
    var normalized = paramValue.toUpperCase().trim();

    for (var i = 0; i < dataList.length; i++) {
      var itemId = (dataList[i][MATCH_FIELD] || '').toUpperCase().trim();
      if (itemId === normalized) {
        matchedItem = dataList[i];
        break;
      }
    }

    if (matchedItem) {
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(matchedItem)); } catch (e) {}
    }
  } else {
    try {
      var stored = sessionStorage.getItem(STORAGE_KEY);
      if (stored) {
        matchedItem = JSON.parse(stored);
      }
    } catch (e) {}
  }

  if (!matchedItem) return;

  var attributes = {};
  Object.keys(matchedItem).forEach(function (key) {
    var value = matchedItem[key];
    if (value !== null && value !== undefined && value !== '') {
      attributes[ATTR_PREFIX + key] = String(value);
    }
  });

  fetch(Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: attributes })
  }).catch(function () {});
})();
